import includes from 'lodash/includes';
import { useMemo } from 'react';
import { PermissionSetType, UserType } from 'api/models';
import { useAccountDataQuery, useAllCompanies } from 'queries/account';
import { AccountPermissionSetType } from 'stores/permission-sets';
import { useUserSafe } from '../use-user';
const useUserPermissions = ()=>{
    var _useUserSafe;
    return (_useUserSafe = useUserSafe()) === null || _useUserSafe === void 0 ? void 0 : _useUserSafe.permissions;
};
export const useUserPermissionSetType = ()=>{
    var _useUserPermissions;
    return (_useUserPermissions = useUserPermissions()) === null || _useUserPermissions === void 0 ? void 0 : _useUserPermissions.permissionSet.permissionSetType;
};
const useCurrentUserProjectPermission = ([, projectId])=>{
    var _useUserPermissions_projects, _useUserPermissions;
    return (_useUserPermissions = useUserPermissions()) === null || _useUserPermissions === void 0 ? void 0 : (_useUserPermissions_projects = _useUserPermissions.projects) === null || _useUserPermissions_projects === void 0 ? void 0 : _useUserPermissions_projects[projectId];
};
const useCurrentUserProjectPermissionSet = (projectId)=>{
    const projectPermission = useCurrentUserProjectPermission(projectId);
    return projectPermission ? projectPermission.permissionSet : null;
};
const useCurrentUserProjectPermissionSetType = (projectId)=>{
    const permissionSet = useCurrentUserProjectPermissionSet(projectId);
    return permissionSet ? permissionSet.permissionSetType : null;
};
const useIsCurrentUserProjectAdmin = (projectId)=>{
    const type = useCurrentUserProjectPermissionSetType(projectId);
    const currentUserPermissionSetType = useUserPermissionSetType();
    return type === PermissionSetType.ProjectOwner || includes([
        PermissionSetType.AccountAdmin,
        PermissionSetType.SuperUser
    ], currentUserPermissionSetType);
};
const useIsCurrentUserVendorCollaborator = (projectId)=>{
    const type = useCurrentUserProjectPermissionSetType(projectId);
    return PermissionSetType.Collaborator === type;
};
const useIsCurrentUserCustomerCollaborator = (projectId)=>{
    const type = useCurrentUserProjectPermissionSetType(projectId);
    return includes([
        PermissionSetType.CustomerChampion,
        PermissionSetType.CustomerCollaborator
    ], type);
};
export const useCurrentUserProjectAccess = (projectId)=>{
    const permissionSetType = useCurrentUserProjectPermissionSetType(projectId);
    const isProjectAdmin = useIsCurrentUserProjectAdmin(projectId);
    const isVendorCollaborator = useIsCurrentUserVendorCollaborator(projectId);
    const isCustomerCollaborator = useIsCurrentUserCustomerCollaborator(projectId);
    return {
        permissionSetType,
        isProjectAdmin,
        isVendorCollaborator,
        isCustomerCollaborator
    };
};
export const useIsCurrentUserCollaborator = ()=>{
    const currentUserPermissionSetType = useUserPermissionSetType();
    const isCollaborator = currentUserPermissionSetType === AccountPermissionSetType.VendorCollaborator;
    return isCollaborator;
};
export const useCurrentUserAcceLevel = ()=>{
    var _data_userProfile_user_company;
    const { data } = useAccountDataQuery();
    const userType = data === null || data === void 0 ? void 0 : data.userProfile.user.userType;
    const currentUserCompanyId = data === null || data === void 0 ? void 0 : (_data_userProfile_user_company = data.userProfile.user.company) === null || _data_userProfile_user_company === void 0 ? void 0 : _data_userProfile_user_company.companyId;
    const { data: partnerCompanies } = useAllCompanies();
    return useMemo(()=>{
        var _find_accessLevel, _find;
        return userType === UserType.Partner ? (_find = (partnerCompanies !== null && partnerCompanies !== void 0 ? partnerCompanies : []).find(({ companyId })=>companyId === currentUserCompanyId)) === null || _find === void 0 ? void 0 : (_find_accessLevel = _find.accessLevel) === null || _find_accessLevel === void 0 ? void 0 : _find_accessLevel.partnerPermissionSetName : undefined;
    }, [
        currentUserCompanyId,
        partnerCompanies,
        userType
    ]);
};
